import { Box } from '@mui/material';
import * as React from 'react';
import { flexCenter } from '../../commonUI/cssClasses';
import colorWheelLottie from '../../commonUI/icons/color-wheel.json';
import LottiePlayer from '../../commonUI/LottiePlayer';
import TooltipPopup from '../../commonUI/tooltips/TooltipPopup';
import ColorSettingsPopup from './ColorSettingsPopup';

export const ColorIcon: React.FC = () => {
  return (
    <TooltipPopup popupComponent={<ColorSettingsPopup />} colorScheme='dark'>
      <Box sx={{ ...flexCenter }}>
        <LottiePlayer lottieJSON={colorWheelLottie} playOnHover pxSize={32} />
      </Box>
    </TooltipPopup>
  );
};
